<template>
  <div class="content">
    <div class="back" @click="backBtn">
      <i></i>
      <span>返回</span>
    </div>
    <!-- 表格内容 -->
    <sys-table ref="sysTable"
                   :tableList="answerExamtUserList"
                   rowKey="id"
                   :showIndex="true"
                   operationWidth="200px"
                   :columList="answerColumList"
                   v-loading="isLoading">
      <template #slotButton="slotProps">
        <el-button type="text" size="medium" @click.stop="handlerSeeDetail(slotProps.rowData)">查看详情</el-button>
      </template>
    </sys-table>

    <!-- 查看题目详情弹框 -->

    <!-- 分页 -->
    <div class="footBox">
      <div class="footPage">
        <p>
          共有{{ pageParms.total }}条记录
        </p>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="pageParms.currentPage"
          :page-size="pageParms.pageSize"
          :page-sizes="pageParms.pagesizesArr"
          layout="prev, pager, next, sizes, jumper"
          :total="pageParms.total"
          class="pagination">
        </el-pagination>
      </div>
    </div>

    <!-- 查看题目详情弹框 -->
    <sys-dialog
      :title="messageDialog.title"
      :width="messageDialog.width"
      :height="messageDialog.height"
      :visible="messageDialog.visible"
      :isShowCancle="messageDialog.isShowCancle"
      @onConfirm="messageConfirm"
      @onClose="messageClose">
      <div slot="content" class="message-text">
        <answer-exam-user-detail :answerExamtPaperTests="answerExamtPaperTests" :rowExamName="rowExamName"></answer-exam-user-detail>
      </div>
    </sys-dialog>

  </div>
</template>

<script>
import $answer from "@/api/answerExam.js";
import SysTable from "@/components/system/SysTable";
import SysDialog from "@/components/system/SysDialog";
import AnswerExamUserDetail from "@/components/answerExam/AnswerExamUserDetail";
export default {
  components: {
    SysTable,
    SysDialog,
    AnswerExamUserDetail,
  },
  data() {
    return {
      answerExamtPaperTests:[],
      isLoading: false,
      // 考生列表数据
      answerExamtUserList: [],
      pageParms:{
        // 当前页
        currentPage: 1,
        pageSize: 10,
        pagesizesArr: [5, 10, 20, 50, 100],
        // 总数量
        total: 100,
      },
      answerColumList:[
        {
          prop: "RealName",
          lable: "姓名",
          width:"",
          align:"center",
        },
        {
          prop: "UserName",
          lable: "考生账号",
          width:"",
          align:"center",
        },
        {
          prop: "Telephone",
          lable: "手机号",
          width:"",
          align:"center",
        },
        {
          prop: "HospitalName",
          lable: "医院名称",
          width:"",
          align:"center"
        },
        {
          prop: "DepartmentName",
          lable: "科室",
          width:"",
          align:"center",
        },
        {
          prop: "PTitle",
          lable: "职称",
          width:"",
          align:"center",
        },
        {
          prop: "source",
          lable: "扫码方式",
          width:"",
          align:"center",
          type:"phoneSource"
        },
        {
          prop: "begin_time",
          lable: "开始时间",
          width:"150px",
          align:"center",
          type:"dateHHmm"
        },
        {
          prop: "end_time",
          lable: "结束时间",
          width:"150px",
          align:"center",
          type:"dateHHmm"
        },
        {
          prop: "stay_time",
          lable: "停留时间",
          width:"",
          align:"center",
          type:"HMS"
        }
      ],
      messageDialog:{
        title:"问卷详情",
        width:600,
        height:700,
        visible:false,
      },
      rowExamName:''
    };
  },
  methods: {
    handlerSeeDetail:async function(row){
      this.isLoading = true;
      const parms = {};
      this.UtilFun(parms);
      parms.examId = row.examId;
      parms.examResultId = row.examResultId;
      const { data } = await $answer.getAnswerExamUserPaperTest(parms);
      if (data.Status === 200) {
        this.rowExamName = this.$parent.$children[0].rowExamName;
        this.answerExamtPaperTests = data.Data;
        this.messageDialog.visible = true;
      } else {
        this.$message.error("获取调查问卷题目失败！");
      }
      this.isLoading = false
    },
    getAnswerExamUserList:async function(){
      this.isLoading = true;
      const parms = {};
      this.UtilFun(parms);
      parms.pageIndex = this.pageParms.currentPage - 1;
      parms.pageShow = this.pageParms.pageSize;
      parms.examId = this.$parent.$children[0].rowExamId;
      const { data } = await $answer.getAnswerExamUserList(parms);
      if (data.Status === 200) {
        this.answerExamtUserList = data.Data.data;
        this.pageParms.total = data.Data.count;
      } else {
        this.$message.error("获取用户信息失败！");
      }
      setTimeout(() => {
        this.isLoading = false;
      }, 200);
    },
    // 显示条数
    handleSizeChange:function(val) {
      // 改变每页显示条数的时候调用一次
      this.pageParms.currentPage = 1;
      this.pageParms.pageSize = val;
      this.getAnswerExamUserList();
      console.log(`每页 ${val} 条`);
    },
    // 分页
    handleCurrentChange:function(val) {
      console.log(`当前页: ${val}`);
      this.pageParms.currentPage = val;
      this.getAnswerExamUserList();
    },
    // 封装方法
    UtilFun:function(paraObj) {
      paraObj.hid = parseInt(this.$store.state.hid);
      paraObj.userID = parseInt(this.$store.state.userID);
      paraObj.guid = this.$store.state.user;
      return paraObj;
    },
    //返回
    backBtn:function() {
      this.$parent.changes(0);
    },
    messageConfirm:function(){
      this.messageDialog.visible = false;
    },
    messageClose:function(){
      this.messageDialog.visible = false;
    },
  },
  //被keep-alive组件包裹时使用
  activated() {
    console.log("执行了answerSubmitUserDetail=======");
    this.getAnswerExamUserList();
  },
};
</script>

<style lang="scss" scoped>
.content {
  height: 100%;
  width: 100%;
  padding: 0px 24px !important;
  min-width: 1650px;
  background-color: rgb(255, 255, 255);
  .back {
    border-bottom: 1px solid #f8f8f8;
    background-color: #FFF;
    width: 140px;
    padding: 10px;
    i {
      display: inline-block;
      width: 12px;
      height: 12px;
      border-top: 2px solid #999999;
      border-left: 2px solid #999999;
      transform: scaleY(0.6) rotate(-45deg);
    }
    span {
      cursor: pointer;
      width: 47px;
      height: 25px;
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #999999;
    }
  }
  .content-top{
    ::v-deep .el-form-item__label{
      font-size: 15px;
      font-weight: 400;
      color: #333333;
    }
    ::v-deep .el-form-item{
      margin-right: 30px;
    }
    ::v-deep .el-input{
      width: 200px;
    }
    padding-top: 24px;
  }
}

.operaBtn {
  display: flex;
  margin: 14px 0px 20px 0px;
  width: 849px;
  height: 40px;
  opacity: 1;
  .el-button + .el-button {
    margin-left: 24px;
  }
  border-radius: 4px;
  ::v-deep .el-button {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    letter-spacing: 1px;
    span > i {
      font-size: 14px !important;
      margin-right: 5px;
    }
  }
  .el-button:nth-child(1) {
    background: #1890ff;
    width: 114px;
  }
}


.footBox {
  position: relative;
  height: 110px;
  .footPage {
    align-items: center;
    display: flex;
    position: absolute;
    right: 16px;
    bottom: 30px;

    span {
      line-height: 32px;
      font-size: 15px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #333333;
      b {
        color: #ff0000;
      }
    }
  }
  .pagination {
    ::v-deep .el-pager {
      li {
        border: 1px solid #d9d9d9;
        margin-right: 8px;
        &.active {
          color: #ffffff;
          background-color: #409eff;
          border: none;
        }
      }
    }
    ::v-deep .el-pagination__jump {
      margin: 0px 10px 0px 0px !important;
    }
  }
}

.message-text{
  display: flex;
  i {
    font-size: 16px;
    color: #ffc664;
    margin-right: 10px;
    transform: translateY(4px);
  }
  p {
    text-align: left;
    font-size: 15px;
    font-weight: 400;
    line-height: 26px;
    color: #333333;
    opacity: 1;
  }
}
</style>
